import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environment/environment';
import { BehaviorSubject, Observable, Subject, map } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { attempt } from 'lodash';
@Injectable({
  providedIn: 'root',
})
export class UserService {

  ROLE_MANAGER = 'MANAGER';
  ROLE_EMPLOYEE = 'EMPLOYEE';
  ROLE_APPLICANT = 'APPLICANT';
  ROLE_ADMIN = 'ADMIN';
  ROLE_TRAINEE = 'TRAINEE';
  lang: any
  loadLang: Subject<any> = new Subject();
  me: any;
  storage = sessionStorage;
  apiUrl = environment.apiUrl;
  utils: any;
  url: string;
  private selectedReportUser = 'selectedUserReport';
  private selectedLoggedEmployee = 'selectedUser';
  selectedUser: any;
  private selectedReportKey = 'selectedReport';
  private selectedEmployeeKey = 'selectedEmployee';
  selectedEmployee: any;
  private valuesResetSource = new Subject<{ valu: string, valu1: number }>();
  valueReset$ = this.valuesResetSource.asObservable();

  private valuesSource = new Subject<{ value1: string, value2: number }>();
  values$ = this.valuesSource.asObservable();

  private valuesCorridorSource = new Subject<{ value3: string, value4: number }>();
  valueCorriod$ = this.valuesCorridorSource.asObservable();
  private questionnaireStatusSubject = new BehaviorSubject<string>('');
  questionnaireStatus$ = this.questionnaireStatusSubject.asObservable();

  // Firmenlogo in der Kopfzeile: wechselt sofort nach dem Hochladen, ohne Neuladen der Seite
  private companyLogoSubject = new BehaviorSubject<string | null>(null);
  companyLogo$ = this.companyLogoSubject.asObservable();
  setCompanyLogo(url: string | null) { this.companyLogoSubject.next(url); }

  private valuesUserSource = new Subject<{ value5: string, value6: number }>();
  valuesUser$ = this.valuesUserSource.asObservable();
  private valuesCandidateSource = new Subject<{ values: string, valuee: number }>();
  valuesCandidate$ = this.valuesCandidateSource.asObservable();

  private valuesEmployeesSource = new Subject<{ value7: string, value8: number }>();
  valuesEmployees$ = this.valuesEmployeesSource.asObservable();
  selectedLanguage = 'en';
  constructor(private http: HttpClient, public router: Router, private cookieService: CookieService) {
    this.url = environment.apiUrl
    const storedLanguage = localStorage.getItem('selectedLanguage');
    if (storedLanguage) {
      this.selectedLanguage = storedLanguage;
    }
  }
  // Login User
  login(data: any) {
    return this.http.post<any>(`${this.apiUrl}` + '/login/', data).pipe(
      map((user) => {
        // localStorage.setItem('user', JSON.stringify(user));
        return user;
      })
    );
  }

  private userUUID: string | null = null;
  setUserUUID(uuid: string) {
    this.userUUID = uuid;
    return this.userUUID; 
  }

  getUserUUID() {
    return this.userUUID;
  }

  // SignUp User
  signUp(data: any) {
    return this.http.post<any>(`${this.apiUrl}` + '/register/', data).pipe(
      map((user) => {
        //localStorage.setItem('user', JSON.stringify(user));

        return user;
      })
    );
  }
  //Change Password
  changePassword(data: any) {
    return this.http.post<any>(`${this.apiUrl}` + '/changePassword/', data).pipe(
      map((user) => {
        return user;
      })
    );
  }

  updatepassword(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/updatePassword/`, data);
  }

  //user logOut
  logout() {
    this.cookieService.deleteAll();
    localStorage.clear();
    this.router.navigate(['/login']).then(() => {
      window.location.reload();
    }).catch((error) => {
      console.error('Navigation error:', error);
    });

  }

  // get token
  getToken() {
    return this.cookieService.get('authToken');
  }
  //create new organization
  createOrganization(data: any) {
    return this.http.post<any>(`${this.apiUrl}` + '/organization/', data).pipe(
      map((user) => {
        return user;
      })
    );
  }


  // get organization list
  getOrganizations() {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/').pipe(
      map((user) => {
        return user;
      })
    );
  }


  // get organization with id
  getOrganization(id: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + id + '/'
    ).pipe(
      map((user) => {
        return user;
      })
    );
  }

  // get organization with id
  updateCompanyLogo(id: any, formData: FormData) {
    return this.http.patch<any>(`${this.apiUrl}/organization/${id}/`, formData);
  }

  //get all departments list
  getDepartments(organizationId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/department/').pipe(
      map((user) => {
        return user;
      })
    );
  }
  getAllDepartmentUser(organizationId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/department_v2/').pipe(
      map((user) => {
        return user;
      })
    );
  }
  //add department
  addDepartament(organizationId: any, department: any) {
    return this.http.post<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/department/', department).pipe(
      map((name) => {
        return name;
      })
    );

  }


  //addposition
  addPosition(organizationId: any, position: any) {
    return this.http.post<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/position/', position).pipe(
      map((job) => {
        return job;
      })
    );
  }

  //delete Organisation
  deleteOrganization(id: any) {
    return this.http.delete<any>(`${this.apiUrl}` + '/organization/' + id + '/',).pipe(
      map((user) => {
        return user;
      })
    );
  }



  //update Organisation
  updateOrganization(uuid: any, data: any) {
    return this.http.put<any>(`${this.apiUrl}` + '/organization/' + uuid + '/', data).pipe(
      map((user) => {
        return user;
      })
    );
  }

  //Invite
  invite(data: any) {
    return this.http.post<any>(`${this.apiUrl}` + '/invite/', data).pipe(
      map((user) => {
        return user;
      })
    );
  }


  getInvitation(uuid: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/invite/' + uuid + '/').pipe(
      map((user) => {
        return user;
      })
    );
    // var req = _getRequest('/invite/' + uuid + '/', {}, false);
    // return $http(req);
  }

  // Öffentliche Rechtstexte in der aktuellen Fassung (ohne Anmeldung)
  getLegalDocument(docType: string, language: string) {
    return this.http.get<any>(`${this.apiUrl}` + '/legal/' + docType + '/?language=' + language);
  }

  // Löschanfragen (Admin)
  previewDeletion(email: string) {
    return this.http.post<any>(`${this.apiUrl}` + '/data-requests/preview/', { email });
  }

  deletePerson(data: any) {
    return this.http.post<any>(`${this.apiUrl}` + '/data-requests/', data);
  }

  getDeletionLog() {
    return this.http.get<any[]>(`${this.apiUrl}` + '/data-requests/');
  }

  // Verlauf der eigenen Zustimmungen und Widerruf der Einwilligung
  getConsentHistory() {
    return this.http.get<any>(`${this.apiUrl}` + '/consent/history/');
  }

  withdrawConsent(document: string) {
    return this.http.post<any>(`${this.apiUrl}` + '/consent/' + document + '/withdraw/', {});
  }

  // Zustimmung zu den Rechtsdokumenten: Stand lesen und erteilen
  getConsent() {
    return this.http.get<any>(`${this.apiUrl}` + '/consent/');
  }

  giveConsent(data: any) {
    return this.http.post<any>(`${this.apiUrl}` + '/consent/', data);
  }

  acceptInvitation(uuid: any, data: any) {
    return this.http.patch<any>(`${this.apiUrl}` + '/invite/' + uuid + '/', data).pipe(
      map((user) => {
        return user;
      })
    );

  }
  // get User
  getUser() {
    return this.http.get<any>(`${this.apiUrl}` + '/user/').pipe(
      map((user) => {
        return user;
      })
    );
  }

  getInvitationUser() {
    return this.http.get<any>(`${this.apiUrl}` + '/invite/').pipe(
      map((user) => {
        return user;
      })
    );
  }

  getInvitedUsers(company_id: number) {
    return this.http.get<any>(`${this.apiUrl}` + '/invite/?company_id=' + company_id).pipe(
      map((user) => {
        return user;
      })
    );
  }


  //get report user 
  getReportUser(userId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/user/' + userId + '/').pipe(
      map((user) => {
        return user;
      })
    );
  }


  updateUserDetail(organizationId: any, userId: any, updatedFields: any) {
    return this.http.patch<any>(`${this.apiUrl}/organization/${organizationId}/user/${userId}/`, updatedFields).pipe(
      map((response) => {
        return response;
      })
    );
  }


  //delete User
  deleteUser(userId: any) {
    return this.http.delete<any>(`${this.apiUrl}` + '/user/' + userId + '/',).pipe(
      map((user) => {
        return user;
      })
    );
  }

  getUserReport(userId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/user/' + userId + '/',).pipe(
      map((user) => {
        return user;
      })
    );
  }
  findUsers(params: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/user/', params).pipe(
      map((user) => {
        return user;
      })
    );
  }

  //get user list data
  getMe() {
    return this.http.get<any>(`${this.apiUrl}` + '/user/me/').pipe(
      map((user) => {
        return user;
      })
    );
  }
  updateAllUserDetail(userId: any, updatedFields: any) {
    return this.http.patch<any>(`${this.apiUrl}/user/${userId}/`, updatedFields).pipe(
      map((response) => {
        return response;
      })
    );
  }

  //getAll user
  getAllUsers(filters: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/user/' + '?organization=' + filters.organization + '&role=' + filters.role).pipe(
      map((alluser) => {
        return alluser;
      })
    );
  }

  //update user  list data
  updateMe(data: any) {
    return this.http.patch<any>(`${this.apiUrl}` + '/user/me/', data).pipe(
      map((user) => {
        return user;
      })
    );
  }

  //question upload

  uploadQuestions(file: any) {
    var fd = new FormData();
    fd.append('file', file);
    return this.http.post<any>(`${this.apiUrl}` + '/questionUpload/', fd).pipe(
      map((user) => {
        return user;
      })
    );
  }


  updateValues(value1: any, value2: any) {
    this.valuesSource.next({ value1, value2 });
  }
  updateCorridor(value3: any, value4: any) {
    this.valuesCorridorSource.next({ value3, value4 });
  }
  updateGenerate(value5: any, value6: any) {
    this.valuesUserSource.next({ value5, value6 });
  }
  updateCandidate(values: any, valuee: any) {
    this.valuesCandidateSource.next({ values, valuee });
  }

  updateEmployees(value7: any, value8: any) {
    this.valuesEmployeesSource.next({ value7, value8 });
  }
  updateReset(valu: any, valu1: any) {
    this.valuesResetSource.next({ valu, valu1 });
  }

  setSelectedEmployee(employee: any) {
    localStorage.setItem(this.selectedEmployeeKey, JSON.stringify(employee));
  }

  getSelectedEmployee() {
    const storedData = localStorage.getItem(this.selectedEmployeeKey);
    return storedData ? JSON.parse(storedData) : null;
  }

  setCurrentSelectEmp(employee: any) {
    localStorage.setItem(this.selectedLoggedEmployee, JSON.stringify(employee));
  }

  getCurrentSelectEmp() {
    const storedData = localStorage.getItem(this.selectedLoggedEmployee);
    return storedData ? JSON.parse(storedData) : null;
  }


  //get position
  getPositions(organizationId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/position/').pipe(
      map((user) => {
        return user;
      })
    );
  }

  getDescription(user: any) {
    if (user.role === this.ROLE_EMPLOYEE) {
      return user.title;
    }
    else if (user.role === this.ROLE_APPLICANT) {
      return user['position_name'];
    }
    else {
      return null;
    }
  }


  isLoggedSync() {
    if (localStorage['token']) {
      this.storage = localStorage;
    }
    return this.storage['token'] !== undefined && this.storage['token'] !== null;
  }


  isAdminSync() {
    if (!this.isLoggedSync()) {
      return false;
    }
    return this.me && this.me.role === this.ROLE_ADMIN;
  }


  isAdmin() {
    return this.getMe().subscribe((user) => {
      return user.role === this.ROLE_ADMIN;
    });
  }

  isManager() {
    return this.getMe().subscribe((user) => {
      return user.role === this.ROLE_MANAGER;
    });
  }

  isManagerSync() {
    if (!this.isLoggedSync()) {
      return false;
    }
    return this.me && this.me.role === this.ROLE_MANAGER;
  }

  getQuestionaryStatus(organizationId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/questionary/status/').pipe(
      map((user) => {
        return user;
      })
    );
  }


  getQuestionaryReport(organizationId: any, questionaryId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/report/questionary/' + questionaryId).pipe(
      map((user) => {
        return user;
      })
    );
  }

  getQuestionarySummaryReport(organizationId: any, questionaryId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/report/questionary-summary/' + questionaryId).pipe(
      map((user) => {
        return user;
      })
    );
  }

  getUserQuestionaryAnswers(userId: any, questionaryId: any, attempt: any) {
    var answered = {};
    answered = true;
    return this.http.get<any>(`${this.apiUrl}` + '/user/' + userId + '/questionary/' + questionaryId + '/answer/' + attempt + '/', answered).pipe(
      map((user) => {
        return user;
      })
    );
  }


  postUserQuestionaryAnswer(userId: any, questionaryId: any, answer: any, attempt: any) {
    return this.http.post<any>(
      `${this.apiUrl}/user/${userId}/questionary/${questionaryId}/answer/${attempt}/`,
      answer
    );
  }



  getOrganizationUsers(organizationId: any, departmentId: any) {
    var params = {};
    if (departmentId !== undefined) {
      params = departmentId;
    }
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/user/', params).pipe(
      map((user) => {
        return user;
      })
    );

  }


  getInviteOrganization(uuid: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + uuid + '/').pipe(
      map((user) => {
        return user;
      })
    );
  }


  getCorridorIndividualEmployee(organizationId: any, userId: any, res?: any) {
    const getToken = 'Token ' + this.cookieService.get('authToken');
    this.lang = localStorage.getItem('selectedLanguage');
    const headers = new HttpHeaders({
      'Accept-Language': res ? res : this.lang
    });
    const requestOptions = { headers: headers };

    return this.http.get<any>(`${this.apiUrl}/organization/${organizationId}/report/corridor_v2/${userId}/`, requestOptions).pipe(
      map((response) => {
        return response;
      })
    );
  }
  getCorridorEmployee(organizationId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/report/corridor/' + '?destination=employees&source=employees').pipe(
      map((report) => {
        return report;
      })
    );
  }

  //sphere
  getSpheres() {
    return this.http.get<any>(`${this.apiUrl}` + '/sphere/').pipe(
      map((sphere) => {
        return sphere;
      })
    );
  }



  getCorridorReport1(organizationId: any, department: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/report/corridor/' + '?destination=all&source=employees').pipe(
      map((report) => {
        return report;
      })
    );

  }


  setSelectedReport(reportId: any) {
    localStorage.setItem(this.selectedReportKey, reportId);
  }
  getSelectedReport() {
    return localStorage.getItem(this.selectedReportKey);
  }

  setCurrentSelectedReport(reportIds: any) {
    localStorage.setItem(this.selectedReportUser, reportIds);
  }
  getCurrentSelectedReport() {
    return localStorage.getItem(this.selectedReportUser);
  }
  getOrganizationData(organizationId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/').pipe(
      map((user) => {
        return user;
      })
    );
  }

  // Add this method to update questionnaire status
  updateQuestionnaireStatus(status: string) {
    this.questionnaireStatusSubject.next(status);
  }
  // //get UserQuestionaries

  getUserQuestionaries(userId: any, attempt: any, res?: any) {
    const getToken = 'Token ' + this.cookieService.get('authToken');
    this.lang = localStorage.getItem('selectedLanguage');
    const headers = new HttpHeaders({
      'Accept-Language': res ? res : this.lang
    });
    const requestOptions = { headers: headers };
    return this.http.get<any>(`${this.apiUrl}/user/${userId}/questionary/${attempt}/`, requestOptions)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }



  getAttemptQuestionary(userId: any, res?: any) {
    let getToken = 'Token ' + this.cookieService.get('authToken');
    this.lang = localStorage.getItem('selectedLanguage');
    const headers = new HttpHeaders({
      'Accept-Language': res ? res : this.lang
    });
    const requestOptions = { headers: headers };
    return this.http.get<any>(`${this.apiUrl}` + '/user/' + userId + '/questionary/', requestOptions).pipe(
      map((sphere) => {
        return sphere;
      })
    );
  }
  getCorridorCandidate(organizationId: any, objects: any, res?: any) {
    let getToken = 'Token ' + this.cookieService.get('authToken');
    this.lang = localStorage.getItem('selectedLanguage');
    const headers = new HttpHeaders({
      'Accept-Language': res ? res : this.lang
    });
    const requestOptions = { headers: headers };
    var url = `${this.apiUrl}` + '/organization/' + organizationId + '/report/corridor_v2/' + '?destination=candidates&objects=' + objects
    return this.http.get<any>(url, requestOptions).pipe(
      map((report) => {
        return report;
      })
    );

  }
  getCorridorReport(organizationId: any, userUUID: any, departments: any, res?: any, runUuid?: string) {
    this.lang = localStorage.getItem('selectedLanguage');
    const headers = new HttpHeaders({
      'Accept-Language': res ? res : this.lang
    });
    const requestOptions = { headers: headers };
    const dynamicDestination = `uuid:${userUUID}`;
    const departmentUUIDs = Array.isArray(departments) ? departments.map((obj: any) => obj.department) : [departments];
    const departmentss = departmentUUIDs.join(',');

    // Only add departments parameter if it's not empty
    const departmentsParam = departmentss ? `&departments=${departmentss}` : '';
    // runUuid: bestimmter Durchlauf der Person, sonst gilt der letzte abgeschlossene
    const runParam = runUuid ? `&run=${runUuid}` : '';
    const url = `${this.apiUrl}/organization/${organizationId}/report/corridor_v2/?destination=${dynamicDestination}${departmentsParam}${runParam}`;
    return this.http.get<any>(url, requestOptions).pipe(
      map((report) => {
        return report;
      })
    );
  }




  getCorridorEmployeeReport(organizationId: any, userId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/report/corridor/' + '?destination=all&source=' + userId).pipe(
      map((report) => {
        return report;
      })
    );
  }
  getReportDetails(userId: any, res?: any): Observable<any> {
    let getToken = 'Token ' + this.cookieService.get('authToken');
    this.lang = localStorage.getItem('selectedLanguage');
    const headers = new HttpHeaders({
      'Accept-Language': res ? res : this.lang
    });
    const requestOptions = { headers: headers };

    return this.http.get<any>(`${this.apiUrl}/generate_pdf/?source=${userId}`, requestOptions);
  }

  uploadReportImage(image: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/generate_pdf/image/`, { image });
  }

  renderReportPdf(payload: any): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/generate_pdf/render/`, payload, { responseType: 'blob' });
  }

  getCorridorDepartmentReport(organizationId: any, departmentId: any) {
    return this.http.get<any>(`${this.apiUrl}` + '/organization/' + organizationId + '/report/corridor_v2/' + '?department=' + departmentId + '&destination=all').pipe(
      map((report) => {
        return report;
      })
    );
  }




  // Reset Password
  sendEmailResetPassword(data: any, res?: any) {
    let getToken = 'Token ' + this.cookieService.get('authToken');
    this.lang = localStorage.getItem('selectedLanguage');
    const headers = new HttpHeaders({
      'Accept-Language': res ? res : this.lang
    });
    const requestOptions = { headers: headers };
    return this.http.post<any>(`${this.apiUrl}` + '/resetPassword/', data, requestOptions).pipe(
      map((user) => {
        return user;
      })
    );
  }
  multiLinechart() {
    return this.http.get<any>(`${this.apiUrl}` + '/report_sphere/').pipe(
      map((report) => {
        return report;
      })
    );
  }
  deleteInvitedUser(id: string) {
    return this.http.delete(`${environment.apiUrl}/invited-user/${id}/`);
  }
}



